import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../../utility/websiteBuilderZLayers";
import { IWebsiteBuilderSectionOperations, TWebsiteBuilderAddSectionDirection } from "../../../../hooks/nodeOperations/sectionOperations/useWebsiteBuilderSectionOperations";
import { websiteBuilderGenerateDefaultContent } from "../../../../nodes/section/websiteBuilderContent";
import { IWebsiteBuilderRoot } from "../../../../nodes/root/websiteBuilderRoot";
import { TWebsiteBuilderSection, websiteBuilderGetSectionVisibility } from "../../../../nodes/section/websiteBuilderSection";
import { useAppSelector } from "hooks/redux";
import { useWebsiteBuilderEditorContext } from "../../../../websiteBuilderEditorContext";

interface ISectionAddSectionButtonsProps {
  node: TWebsiteBuilderSection;
  root: IWebsiteBuilderRoot;
  hovered: boolean;
  sectionOperations: IWebsiteBuilderSectionOperations;
}

export function SectionAddSectionButtons(props: ISectionAddSectionButtonsProps) {
  const { node, root, hovered, sectionOperations } = props;

  const { type: sectionType } = node.section;

  const { activePageDomNodeRefMap, scrollContainerRef } = useWebsiteBuilderEditorContext();

  const { t } = useTranslation();

  const deviceView = useAppSelector(store => store.websiteBuilderStore.editor.deviceView);
  const activePageId = useAppSelector(store => store.websiteBuilderStore.editor.activePageId);
  const header = useAppSelector(store => store.websiteBuilderStore.editor.header);

  const firstVisibleMainSection = root.children.find(child => child.section.visibility[deviceView]);

  const insetTopButton = deviceView === "desktop" && !websiteBuilderGetSectionVisibility(header, root).desktop && (
    firstVisibleMainSection != null ? firstVisibleMainSection.id === node.id : sectionType === "footer"
  );

  function handleAddSection(direction: TWebsiteBuilderAddSectionDirection) {
    const content = websiteBuilderGenerateDefaultContent();

    sectionOperations.addSection(content, root, node, direction, activePageId, deviceView, activePageDomNodeRefMap, scrollContainerRef);
  }

  return (
    <>
      {hovered && sectionType !== "header" && (
        <button
          className={classNames("website-builder-section-add-section-top-button", {
            "inset": insetTopButton,
          })}
          style={{
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEditorUI,
          }}
          onPointerDown={e => e.stopPropagation()}
          onClick={() => handleAddSection("up")}
        >
          <FontAwesomeIcon icon={faPlus} /> {t("Add Section")}
        </button>
      )}
      {hovered && sectionType !== "footer" && (
        <button
          className="website-builder-section-add-section-bottom-button"
          style={{
            zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEditorUI,
          }}
          onPointerDown={e => e.stopPropagation()}
          onClick={() => handleAddSection("down")}
        >
          <FontAwesomeIcon icon={faPlus} /> {t("Add Section")}
        </button>
      )}
    </>
  );
}
